import { getCountrySpecificRules } from '@helpers/config/countrySpecificRules';

/**
 * Determines if a country has a local VAT number field
 * @param {string} iso ISO code for country
 * @returns {boolean} True if country has local VAT number
 */
export const hasLocalVatNumber = iso =>
  getCountrySpecificRules(iso, 'registrations').hasLocalVatNumber;
